
const FormatAmount = (
  amount: number,
  locale: string = "tr-TR",
  currency: string = "TRY"
): string => {
  const formattedAmount = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    currencyDisplay: "code", // Bu 'TRY' olarak döner
  }).format(amount);

  // 'TRY' yi 'TL' olarak değiştir
  const withTL = formattedAmount.replace(currency, "TL");
  return withTL.endsWith(" TL") ? withTL : withTL.replace("TL", "") + " TL";
};

export const FormatAmountSymbol = (
  amount: number,
  locale: string = "tr-TR",
  currency: string = "TRY"
): string => {
  const parts = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    currencyDisplay: "code",
  }).formatToParts(amount);

  const withoutCurrency = parts
    .filter((p) => p.type !== "currency")
    .map((p) => p.value)
    .join("")
    .trim();

  return `₺${withoutCurrency}`;
};

export default FormatAmount;
